import { MailIcon } from 'lucide-react'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { AuthShell } from '../components/AuthShell'
import {
  PreferenceButton,
  PreferenceCategory,
  PreferenceInfo,
  PreferenceInput,
  PreferenceScreen,
  PreferenceSubmit,
} from '../components/Preference'
import { DEFAULT_APP_PATH, postSignInPath, useMe } from '../lib/auth-client'
import { useClaimAccount } from '../lib/useClaimAccount'

/** Magic-link sign-in. */
export default function LoginEmail() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const next = params.get('next') || DEFAULT_APP_PATH
  const { data: me, isLoading } = useMe()
  const claim = useClaimAccount({ callbackURL: next })

  useEffect(() => {
    if (!me) return
    if (!me.user || me.user.isAnonymous) return
    navigate(postSignInPath(me, next), { replace: true })
  }, [me, navigate, next])

  const checking = isLoading || !me || (me.user != null && !me.user.isAnonymous)

  if (checking) {
    return (
      <AuthShell>
        <PreferenceInfo title="Laden…" />
      </AuthShell>
    )
  }

  return (
    <AuthShell>
      <PreferenceScreen title="Inloggen met e-mail" backHref="/">
        <PreferenceCategory filled>
          {!claim.sent ? (
            <>
              <PreferenceInput
                icon={<MailIcon className="h-6 w-6" />}
                title="E-mailadres"
                type="email"
                autoComplete="email"
                value={claim.email}
                onChange={claim.setEmail}
                placeholder="jij@voorbeeld.be"
                autoFocus
              />
              <PreferenceInfo
                title="Inloglink"
                summary="We sturen een inloglink naar je e-mail."
              />
              <PreferenceSubmit
                title={claim.busy ? 'Bezig…' : 'Stuur inloglink'}
                onPress={() => void claim.sendMagicLink()}
                disabled={claim.busy || !claim.email.trim()}
              />
            </>
          ) : (
            <>
              <PreferenceInfo
                title="Check je inbox"
                summary={`Open de inloglink die we naar ${claim.email} stuurden.`}
              />
              <PreferenceButton
                title="Ander e-mailadres"
                onPress={() => claim.setSent(false)}
              />
            </>
          )}
        </PreferenceCategory>
      </PreferenceScreen>
    </AuthShell>
  )
}
